import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

/**
 * HeroSection Component
 * Main landing section with lockitup branding, tagline, and download CTA
 * Features animated locker icon and centered layout
 */
function HeroSection() {
  return (
    <section className="hero-section">
      <div className="container hero-container">
        {/* Animated Locker Icon */}
        <div className="locker-icon">
          <svg 
            width="120" 
            height="120" 
            viewBox="0 0 120 120" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="locker-svg"
          >
            {/* Locker Body */}
            <rect 
              x="20" 
              y="50" 
              width="80" 
              height="60" 
              rx="5" 
              fill="#27AE60" 
              stroke="#F1C40F" 
              strokeWidth="3"
            />
            
            {/* Shackle */}
            <path 
              d="M 40 50 L 40 35 Q 40 15, 60 15 Q 80 15, 80 35 L 80 50" 
              stroke="#F1C40F" 
              strokeWidth="8" 
              fill="none" 
              strokeLinecap="round"
            />
            
            {/* Keyhole */}
            <circle cx="60" cy="75" r="8" fill="#1A1F36" />
            <rect x="57" y="75" width="6" height="15" fill="#1A1F36" />
            
            {/* Shine effect */}
            <rect 
              x="25" 
              y="55" 
              width="4" 
              height="20" 
              rx="2" 
              fill="rgba(255, 255, 255, 0.3)"
            />
          </svg>
        </div>

        {/* Main Title */}
        <h1 className="hero-title">lockitup</h1>

        {/* Tagline */}
        <p className="hero-tagline">Completely Free. Fully Secure.</p>

        {/* Download Button Container */}
        <div className="download-section">
          <Link 
            to="/download" 
            className="download-button"
          >
            <span className="download-icon">
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  d="M12 3V16M12 16L8 12M12 16L16 12" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                <path 
                  d="M3 17V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V17" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round"
                />
              </svg>
            </span>
            <span>Download lockitup.exe</span>
          </Link>

          {/* Trust Badge */}
          <div className="trust-badge">
            <span className="badge-icon">✓</span>
            <span>100% Free • No Spyware • Windows Compatible</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
